import { AbstractControl } from '@angular/forms';

/**
 * Check whether to show errors for a control.
 *
 * This requires that the control should meet some conditions:
 * • touched — it's gained and lost keyboard focus
 * • dirty — the user has interacted with the control
 * • has any errors at all
 *
 * @param control The control to check
 * @returns Whether to show errors for the control
 */
export function showError(control: AbstractControl): boolean {
  return !!control && control.touched && control.dirty && !!control.errors;
}
